
import { Component, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { IPlant } from "@/interfaces/models/IPlant";
import { PlantStoreMixin } from "@/mixins/Stores/PlantStoreMixin";
import ConsumptionAndWateringChart from "@/components/modules/plant/PlantCharts/ConsumptionAndWateringChart.vue";

@Component({
  components: { ConsumptionAndWateringChart },
})
export default class PlantCharts extends mixins(PlantStoreMixin) {
  @Prop({ required: true })
  public plant!: IPlant;

  @Watch("plant")
  public onPlantChanged(plant: IPlant) {
    if (plant?.id) {
      this.loadPlantConsumptionData({ id: this.plant.id });
    }
  }
}
